
export enum Language {
    simplifiedChinese = "Simplified Chinese",
    traditionalChinese = "Traditional Chinese",
    english = "English",
    spanish = "Spanish",
    russian = "Russian",
    bengali= "Bengali",
    korean = "Korean",
    hindi = "Hindi"
}

export enum TimeFormat {
    YYYYMMDD= "YYYY-MM-DD",
    MMDDYYYY= "MM/DD/YYYY",
    YYYYMMDDHHmmss= "YYYY-MM-DD HH:mm:ss",
    YYYYMMDDTHHmmss= "YYYY-MM-DDTHH:mm:ss",
    MMDDYYYYHHmmss= "MM/DD/YYYY HH:mm:ss",
    HHmmMMDDYYYY= "HH:mm MM/DD/YYYY",
    MMDDYYYYHHmm= "MM/DD/YYYY HH:mm",
    HHmmMMDD= "HH:mm MM/DD",
    HHmm= "HH:mm"
}

export const montShortNameList: Array<String> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
]

export const weekShortNameList = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
]

export enum ActionType {
    new = "new",
    edit = "edit",
    view = "view",
}

export enum PresentationStyle {
    push = "push",
    modal = "modal"
}
